// Floating action bar shown when 2+ objects are selected.
// Batch align / distribute / group / duplicate / delete.
import React from "react";
import {
  AlignStartVertical,
  AlignCenterVertical,
  AlignEndVertical,
  AlignStartHorizontal,
  AlignCenterHorizontal,
  AlignEndHorizontal,
  Group,
  Ungroup,
  Copy,
  Trash2,
} from "lucide-react";

function BarButton({ title, testId, onClick, icon: Icon, disabled }) {
  return (
    <button
      title={title}
      data-testid={testId}
      onClick={onClick}
      disabled={disabled}
      className="h-8 w-8 flex items-center justify-center text-ink2 hover:bg-hover hover:text-ink transition-colors disabled:opacity-30 disabled:hover:bg-transparent"
    >
      <Icon className="h-4 w-4" />
    </button>
  );
}

export default function MultiSelectBar({ count, canUngroup, onAlign, onGroup, onUngroup, onDuplicate, onDelete }) {
  return (
    <div
      data-testid="multi-select-bar"
      className="absolute top-16 left-1/2 -translate-x-1/2 z-20 flex items-center bg-panel border border-line shadow-2xl"
    >
      <span
        data-testid="multi-select-count"
        className="px-3 text-[10px] font-mono uppercase tracking-widest text-[#FF6B00]"
      >
        {count} sel
      </span>
      <div className="tool-divider" />
      <BarButton title="Align Left" testId="align-left-btn" icon={AlignStartVertical} onClick={() => onAlign("left")} />
      <BarButton title="Align Center" testId="align-centerH-btn" icon={AlignCenterVertical} onClick={() => onAlign("centerH")} />
      <BarButton title="Align Right" testId="align-right-btn" icon={AlignEndVertical} onClick={() => onAlign("right")} />
      <div className="tool-divider" />
      <BarButton title="Align Top" testId="align-top-btn" icon={AlignStartHorizontal} onClick={() => onAlign("top")} />
      <BarButton title="Align Middle" testId="align-middleV-btn" icon={AlignCenterHorizontal} onClick={() => onAlign("middleV")} />
      <BarButton title="Align Bottom" testId="align-bottom-btn" icon={AlignEndHorizontal} onClick={() => onAlign("bottom")} />
      <div className="tool-divider" />
      <BarButton title="Group (Ctrl+G)" testId="group-btn" icon={Group} onClick={onGroup} />
      <BarButton title="Ungroup (Ctrl+Shift+G)" testId="ungroup-btn" icon={Ungroup} onClick={onUngroup} disabled={!canUngroup} />
      <div className="tool-divider" />
      <BarButton title="Duplicate (Ctrl+D)" testId="multi-duplicate-btn" icon={Copy} onClick={onDuplicate} />
      <BarButton title="Delete (Del)" testId="multi-delete-btn" icon={Trash2} onClick={onDelete} />
    </div>
  );
}
